import React, { useState } from "react";
import { makeStyles, Typography } from "@material-ui/core";
import Button from "components/design-system/atoms/Button";

import FilterIcon from "../assets/filterIcon.svg";
import FiltersMobilePanel from "./FiltersMobilePanel";
import useFilters from "hooks/useFilters";

export default function FiltersMobileButton({ filters, category, filterComponent, onReset, numberOfFiltersOverride }) {
  const classes = useStyle();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [{ filters: activeFilters }] = useFilters();
  const numberOfFilters =
    numberOfFiltersOverride ||
    Object.keys(activeFilters).filter(
      (k) =>
        k !== "page" &&
        k !== "price_max" &&
        k !== "search" &&
        k !== "category" &&
        k !== "product_type" &&
        k !== "subcategory1" &&
        k !== "category1" &&
        k !== "catalog"
    ).length;

  return (
    <>
      <Button version="invisible" onClick={() => setOpenDrawer(true)}>
        {numberOfFilters > 0 ? "Filtres" : "Filtrer"}
        {numberOfFilters > 0 ? (
          <Typography align="center" className={classes.number}>
            {numberOfFilters}
          </Typography>
        ) : (
          <FilterIcon className={classes.icon} />
        )}
      </Button>
      <FiltersMobilePanel
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        filters={filters}
        category={category}
        filterComponent={filterComponent}
        onReset={onReset}
      />
    </>
  );
}

const useStyle = makeStyles((theme) => ({
  icon: {
    marginLeft: theme.spacing(1),
  },
  number: {
    height: 25,
    minWidth: 25,
    minHeight: 25,
    width: 25,
    borderRadius: 50,
    marginLeft: theme.spacing(2),
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    fontSize: 16,
    color: "white",
    backgroundColor: theme.palette.secondary.main,
  },
}));
